export var LoginErrorsEnum;
(function (LoginErrorsEnum) {
  LoginErrorsEnum["API"] = "api";
  LoginErrorsEnum["NO_MATCH"] = "noMatch";
  LoginErrorsEnum["INVALID_EMAIL"] = "email";
  LoginErrorsEnum["NO_CHEGG_ACCOUNT"] = "noCheggAccount";
  LoginErrorsEnum["MFA_CHALLENGE_DETAILS"] = "mfaChallengeDetails";
  LoginErrorsEnum["LOCKED_SUSPICIOUS_ACTIVITY"] = "lockedSuspiciousActivity";
})(LoginErrorsEnum || (LoginErrorsEnum = {}));